import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    loaded: { type: Boolean, default: false }
  }

  connect() {
    this.setupIntersectionObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupIntersectionObserver() {
    // Load Swiper when element is within 300px of viewport
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loadedValue) {
            this.loadSwiper()
          }
        })
      },
      { rootMargin: '300px' }
    )

    this.observer.observe(this.element)
  }

  loadSwiper() {
    if (this.loadedValue) return
    this.loadedValue = true

    // Check if Swiper is already available
    if (typeof Swiper !== 'undefined') {
      this.initializeSwiper()
      return
    }

    // Load Swiper JS dynamically
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js'
    script.async = true
    script.onload = () => this.initializeSwiper()
    document.body.appendChild(script)

    // Disconnect observer since we've loaded
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  initializeSwiper() {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      console.error('Swiper is not loaded')
      return
    }

    // Initialize gallery slider
    new Swiper('.gallery-slider', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      }
    })
  }
}
